import { IOption } from '../../../../../../types/IOption';
import { IParameterProperty } from '../../../../../../types/IParameter';
import Parameter from '../../Parameter';

/** makes the options member mandatory */
export interface ISelectParameterProperty extends IParameterProperty {
  options: IOption[];
}

class Select extends Parameter {
  // Public Member
  public options: IOption[];

  constructor(parameter: ISelectParameterProperty) {
    super(
      Object.assign(parameter, {
        value: Select.getInitialValue(parameter),
      }),
    );
    this.options = parameter.options;
  }

  static getInitialValue(parameter: ISelectParameterProperty) {
    // if we only have one option, we set the default value as it will be represented as a readonly input
    if (parameter.options.length === 1) {
      return parameter.options[0].value;
    }
    /* explicitly checking for null as otherwise some cases as 0 or "0"
          will be unintentionally converted to undefined (see SIBZIEL-4475) */
    if (parameter.value === null) {
      return undefined;
    }
    return parameter.value;
  }
}

export default Select;
